import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { artAssets } from "../data/site";
import { Reveal } from "./Reveal";

export function SandWormAd() {
  return (
    <section className="sand-worm-ad" data-testid="sand-worm-ad-section">
      <Reveal className="sand-worm-ad-inner">
        <img loading="lazy"
          className="sand-worm-ad-seal"
          src="/assets/catcher-guild-seal.png"
          alt="A Licensed Sand Worm Catcher — Catcher Guild official seal"
          data-testid="sand-worm-ad-seal"
        />
        <div className="sand-worm-ad-copy">
          <span>HAZARD PERMIT NOTICE</span>
          <h2>Become a Licensed Sand Worm Catcher — only 12,000 credits.</h2>
          <p>Open the field dossier, study the weak points, begin catcher review.</p>
        </div>
        <div className="sand-worm-ad-art" aria-hidden="true">
          <img loading="lazy" src={artAssets.wormXray} alt="" />
        </div>
        <Link to="/character-book" className="button button-primary" data-testid="home-sand-worm-ad-link">
          OPEN WORM DOSSIER <ArrowUpRight size={16} />
        </Link>
      </Reveal>
    </section>
  );
}
